/**
 * دریافت عنوان تعطیلات از holidayapi.ir (منبع: time.ir)
 * با کش localStorage برای سال‌هایی که دادهٔ آفلاین ندارند یا به‌روزرسانی نیاز دارند.
 */

const CACHE_KEY = 'crm-national-holiday-titles-v1';
const CACHE_TTL_MS = 90 * 24 * 60 * 60 * 1000;
const API_BASE = 'https://holidayapi.ir/jalali';

const readCache = () => {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return { entries: {}, fetchedAt: 0 };
    return JSON.parse(raw);
  } catch {
    return { entries: {}, fetchedAt: 0 };
  }
};

const writeCache = (data) => {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota errors */
  }
};

const extractHolidayTitles = (payload) => {
  const events = payload?.events || [];
  return events
    .filter((e) => e?.is_holiday && e.description && e.description !== 'جمعه')
    .map((e) => e.description.trim())
    .filter(Boolean)
    .join(' / ');
};

/** دریافت عنوان یک روز از API (با کش) */
export const fetchHolidayTitleForDate = async (year, month, day) => {
  const key = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  const cache = readCache();
  const cached = cache.entries?.[key];
  if (cached && Date.now() - (cached.at || 0) < CACHE_TTL_MS) {
    return cached.title || null;
  }

  try {
    const res = await fetch(`${API_BASE}/${year}/${month}/${day}`, {
      signal: AbortSignal.timeout(8000),
    });
    if (!res.ok) return cached?.title || null;
    const data = await res.json();
    const title = extractHolidayTitles(data);
    if (title) {
      cache.entries[key] = { title, at: Date.now() };
      cache.fetchedAt = Date.now();
      writeCache(cache);
    }
    return title || cached?.title || null;
  } catch {
    return cached?.title || null;
  }
};

/** تکمیل عنوان روزهای بدون عنوان در نقشه تعطیلات */
export const enrichHolidayMapTitles = async (map, keysWithoutTitle = []) => {
  if (!keysWithoutTitle.length) return map;

  const batchSize = 4;
  for (let i = 0; i < keysWithoutTitle.length; i += batchSize) {
    const batch = keysWithoutTitle.slice(i, i + batchSize);
    await Promise.all(
      batch.map(async (key) => {
        const [y, m, d] = key.split('-').map(Number);
        const title = await fetchHolidayTitleForDate(y, m, d);
        if (title) map.set(key, title);
      }),
    );
  }
  return map;
};

export const clearHolidayApiCache = () => {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    /* ignore */
  }
};
